/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMapLocationsRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetMapLocationsResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getMapLocations = (request:GetMapLocationsRequest, options?: CashRequestOptions) => post<GetMapLocationsRequest, GetMapLocationsResponse>("/2.0/cash/get-map-locations", request, {...options, rejectOnError: true })